import AccountDashboard from '@/pages/Dashboard/AccountDashboard'
import SellpointDashboard from '@/pages/Dashboard/SellpointDashboard'
import TemplateDashboard from '@/pages/Dashboard/TemplateDashboard'
export default {
    path: '/dashboard',
    component: TemplateDashboard,
    children: [
      {
        path: '',
        name: 'AccountDashboard',
        component: AccountDashboard
      },
      {
        path: ':id',
        name: 'SellpointDashboard',
        component: SellpointDashboard
      },
     
    ]
}



// WEBPACK FOOTER //
// ./src/router/dashboard.js